import type { Reducer } from 'redux';
import type { IVehicle } from '@makemydeal/dr-platform-types';
import { Actions } from '../actionTypes/actionTypes';

export const vehicle: Reducer<IVehicle> = (state: IVehicle = {} as IVehicle, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case Actions.BUY_THIS_VEHICLE: {
            return {
                ...payload.vehicle
            };
        }
        case Actions.HANDLE_CANCEL_EVENT: {
            return {
                ...state
            };
        }
        default: {
            return state;
        }
    }
};
